export default __webpack_public_path__ + "static/media/noimagegold.fbe48801.png";